import { render, staticRenderFns } from "./colorSetting.vue?vue&type=template&id=932ae690&scoped=true&"
import script from "./colorSetting.vue?vue&type=script&lang=js&"
export * from "./colorSetting.vue?vue&type=script&lang=js&"
import style0 from "./colorSetting.vue?vue&type=style&index=0&id=932ae690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932ae690",
  null
  
)

export default component.exports